<template>
  <div>
    <!-- .search -->
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <b-link :to="{name:'dashboard'}">Admin</b-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Entries</li>
      </ol>
    </nav>
    <div class="px-3">
      <div class="form-group search">
        <input
          type="text"
          class="form-control"
          id="search"
          placeholder="...search"
          v-model="search"
        >
      </div>
      <div v-for="entrant in entrants" :key="entrant.uid">
        <div v-if="entrant.name" v-show="entrant.name.includes(search) || search===''">
          <div
            v-for="entry in entrant.entries"
            :key="entry.eid"
            class="mb-4 entry"
            :class="[entry.complete ? 'complete': 'inprogress']"
          >
            <span
              class="badge badge-pill"
              :class="[entry.complete ? 'badge-primary': 'badge-secondary']"
            >{{Object.keys(entry.photos).length}}</span>
            <h3>
              <span class="title">
                <router-link
                  :to="{ name: 'admin-show-entry', params: { uid: entrant.uid, eid: entry.eid, name: entrant.name, email: entrant.email} }"
                  class="link"
                >{{entry.title ? entry.title : '...project yet to be titled'}}</router-link>
              </span>
              <span class="author">by
                <router-link
                  :to="{ name: 'admin-list-entries', params: { uid: entrant.uid, name: entrant.name, email: entrant.email} }"
                  class="link"
                >{{entrant.name}}</router-link>
              </span>
            </h3>
            <div class="meta">
              <span
                class="status"
              >{{entry.complete ? 'submitted for review': 'submission in-progress'}},</span>
              <span class="mail">
                <a :href="`mailto:${entrant.email}`">{{entrant.email}}</a>
              </span>
            </div>
            <gallery-strip :photos="entry.photos"/>
          </div>
        </div>
        <!--.search -->
      </div>
      <!-- entrant in entrants -->
    </div>
    <!--.px-1 -->
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import GalleryStrip from '@/components/admin/GalleryStrip.vue'
export default {
  data() {
    return {
      search: ''
    }
  },
  components: { GalleryStrip },
  computed: {
    ...mapState({
      entrants: state => state.admin.entrands
    }),
    ...mapGetters({
      // entrants: 'admin/entrants',
      completedEntryCount: 'admin/completedEntryCount',
      uploadedPhotoCount: 'admin/uploadedPhotoCount'
    })
  },
  methods: {},
  mounted() {}
}
</script>

<style scoped>
h3 {
  display: inline-block;
}
h3 span.title {
  font-weight: 200;
}
h3 span.author {
  font-weight: 100;
  font-size: 0.7em;
  padding-left: 0.4em;
}

div.meta {
  display: inline-block;
  font-weight: 100;
}
span.mail:before {
  content: ' ';
}

div.meta:before {
  content: '\2014';
  padding: 0 0.5em;
  font-weight: 100;
}
.entry .badge {
  vertical-align: top;
  margin-right: 1em;
}
</style>
